import util from "../util";

let controller = "OperadorAnalisePermissoes";
export default Object.assign({}, util.GetCrud(controller, ['getall', 'post', 'put']), {
  GetAtivos: () => {
    return util.Axios.GetAll(controller + "/Ativos");
  },
  ObterOperadoresAnaliseHistorico: () => {
    return util.Axios.GetAll(controller + "/Historico");
  },
  GetAnalisesPendentesAprovacao(dto) {
    return util.Axios.GetAll(controller + '/AnalisesPendentes', dto);
  },
  ObterOperadoresComPerfilSeguranca(dto) {
    return util.Axios.Get(controller + "/OperadoresComPerfilSeguranca");
  },
  AtualizarAnalisesExpiradas(){
    return util.Axios.Put(controller + "/AtualizarAnalisesExpiradas", '', {});
  }
});
